import * as d3 from "d3";
import * as d3Zoom from "d3-zoom";

import { useEffect, useRef } from "react";

export const useD3 = (renderChartFn, dependencies) => {
  const ref = useRef();

  useEffect(() => {
    const svg = d3.select(ref.current);
    svg.selectAll("*").remove();
    d3.selectAll("body").select("#treetooltip").remove(); // Ensure your tooltip has a class or ID that you can select
    renderChartFn(d3.select(ref.current));

    return () => {};
  }, dependencies);
  return ref;
};

//Coulnd't get the svg to update using the UseD3 hook, as it didn't recognise
// the new nodes and edges. Therefore have explicitly achknowledged them here.

export const useD3Graph = (renderChartFn, nodes, edges, simulation) => {
  const ref = useRef();

  useEffect(() => {
    const svg = d3.select(ref.current);

    renderChartFn(svg, nodes, edges);

    return () => {};
  }, [nodes, edges, renderChartFn]);

  return ref;
};
